import EStateAsyncStatus from "@/constants/stateAsyncState";
import { useAppSelector } from "@/hooks/useRedux";
import { categoriesList } from "@/store/slices/categorySlice";
import { isEqual } from "lodash";
import { Image } from "@nextui-org/react";
import { FaInstagram } from "react-icons/fa";
import Link from "next/link";
import SkeletonElement from "@/components/Shares/SkeletonElement";
import dynamic from "next/dynamic";

const CustomScrollBarNoSSR = dynamic(
  () => import("@/components/Shares/CustomScrollBar"),
  { ssr: false },
);

const LookingFor = () => {
  const category = useAppSelector(categoriesList);

  return (
    <div className="container mx-auto flex flex-col md:flex-row gap-6 pt-28 overflow-hidden">
      <div className="w-[392px]">
        <div className="grid grid-cols-7 ">
          <div className="size-14 border-r border-b border-icon col-span-1"></div>
          <div className="pl-7 border-b border-icon col-span-6">
            <div className="flex justify-between items-end">
              <h2 className="text-5xl">Picks</h2>
              <Link
                href="https://www.instagram.com/priceworthfurniture.vic/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <span className="text-sm text-icon flex items-center gap-2">
                  <FaInstagram className="text-lg" />
                  priceworth
                </span>
              </Link>
            </div>
          </div>
          <div className="rotate-180 flex justify-end border-l border-icon writing-vertical text-5xl pb-7 col-span-1 h-96">
            <h2>Room</h2>
          </div>
          <div className="flex col-span-6 items-center justify-center">
            <p className="text-lg max-w-[229px] ">
              Discover our furniture, thoughtfully arranged by room. ({`We’ve `}
              curated each space so you can browse freely—and find what fits
              your style, beautifully.)
            </p>
          </div>
        </div>
      </div>
      <div className="flex-1 pt-14">
        <CustomScrollBarNoSSR style={{ height: 350 }}>
          <div className="flex gap-6">
            {isEqual(category.status, EStateAsyncStatus.succeeded) &&
            Array.isArray(category.categoriesList) &&
            category.categoriesList.length > 0
              ? category.categoriesList.map((item, index) => {
                  if (!item.published) return null;
                  return (
                    <div
                      key={index}
                      className="flex flex-col gap-4 min-w-[276px]"
                    >
                      <Link href={`/category/${item.slug}`}>
                        <div className="size-[276px]">
                          <Image
                            radius="none"
                            src={item.image}
                            alt={item.name}
                            className="w-full h-[276px] object-cover"
                          />
                        </div>
                      </Link>
                      <Link href={`/category/${item.slug}`}>
                        <p className="text-center hover:text-icon transition-all duration-500">
                          {item.name}
                        </p>
                      </Link>
                    </div>
                  );
                })
              : [...Array(10)].map((_, index) => (
                  <div
                    key={`placeholder-${index}`}
                    className="flex flex-col gap-4 min-w-[276px]"
                  >
                    <div className="size-[276px]">
                      <SkeletonElement />
                    </div>
                  </div>
                ))}
          </div>
        </CustomScrollBarNoSSR>
      </div>
    </div>
  );
};

export default LookingFor;
